import React from "react";
import { List, Typography, Divider } from "antd";

const { Text } = Typography;

// 原始数据（保留重复项，与图片一致）

const Chart1 = (props) => {
  const data = props.data || [];
  return (
    <div
      style={{
        padding: 24,
      }}
    >
      <Divider />
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item, index) => (
          <List.Item
            key={index}
            style={{ display: "block", padding: "12px 0" }}
          >
            {/* 第一行：日期 + 站点 */}
            <div
              style={{
                fontSize: 18,
                color: "#666",
                marginBottom: 10,
                marginRight: 32,
              }}
            >
              {item.date} {item.pointName}
            </div>
            {/* 第二行：骑手姓名 + 接单量 + 骑手ID */}
            <div style={{ fontSize: 16 }}>
              <Text strong style={{ marginRight: 32 }}>
                {item.staffName}
              </Text>
              <Text type="secondary" style={{ marginRight: 32 }}>
                接单量：{item.validOrderCount}
              </Text>
              <Text type="secondary">骑手ID：{item.eleCourierId}</Text>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default Chart1;
